import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import { ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { buildRows } from '../assets/js/common'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.ON_DEMAND_APP_DEVELOPMENT)


const ON_DEMAND_FEATURES = [
  {
    title: 'Rich & Intuitive User Experiences',
    desc: 'We create modern, responsive interfaces with rich UI components, intuitive navigation, interactive elements, and consistent design systems across web and mobile applications.',
  },
  {
    title: 'Modern Development Practices',
    desc: 'Our development teams follow structured coding standards, reusable components, version control, code reviews, automated testing, and established engineering practices to create clean, maintainable software.',
  },
  {
    title: 'Reliable & Secure Applications',
    desc: 'We build applications with security, performance, reliability, and maintainability in mind—from application architecture and API design to testing, deployment, and ongoing improvements.',
  },
  {
    title: 'Architectures Built to Scale',
    desc: 'Applications are designed with modular and scalable architectures that allow you to add users, features, integrations, and workloads without having to rebuild the entire system.',
  },
]

const ON_DEMAND_LIFECYCLE = ['Discover', 'Design', 'Architect', 'Develop', 'Test', 'Deploy', 'Evolve']

const ON_DEMAND_IMG_BASE = '/assets/images/client-work-2'

const ON_DEMAND_CAPABILITIES = [
  {
    title: 'Web Application Development',
    desc: 'Modern, responsive web applications designed for business users, customers, partners, and internal teams.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'web.jpg',
  },
  {
    title: 'Mobile Application Development',
    desc: 'User-focused mobile applications for iOS and Android, built around your business workflows and customer needs.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'mobile.jpg',
  },
  {
    title: 'Enterprise & Business Applications',
    desc: 'Custom applications that digitize processes, connect teams, and improve operational efficiency.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'enterprise-business.jpg',
  },
  {
    title: 'Workflow & Process Automation',
    desc: 'Applications that simplify repetitive processes, reduce manual effort, and improve visibility across business operations.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'automation.jpg',
  },
  {
    title: 'API & System Integration',
    desc: 'Secure and scalable APIs that connect applications, services, databases, third-party platforms, and enterprise systems.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'api-system-integration.jpg',
  },
  {
    title: 'Cloud-Ready Application Development',
    desc: 'Applications designed to take advantage of cloud infrastructure, scalability, availability, and modern deployment practices.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'cloud-ready.jpg',
  },
  {
    title: 'Application Modernization',
    desc: 'Modernize legacy applications, architectures, and technology stacks while preserving valuable business functionality.',
    features: ['Feature 1', 'Feature 2', 'Feature 3', 'Feature 4'],
    image: 'modernization.jpg',
  },
]
const APPROACH_FOCUS = [
  { name: 'Web application and API security',    color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Application architecture and access controls',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Data protection and privacy',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  { name: 'Cloud and infrastructure security',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Vulnerability and risk management',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Accessibility and usability',           color: { bg: '#9bcf60', text: '#2e5a0e' } },
  { name: 'Security policies and governance',      color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  
   { name: 'Compliance and audit readiness',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  
]
export default function OnDemandAppDevelopment() {
  
const domainRows = buildRows(APPROACH_FOCUS)
  return (
    <>
    {/* <MetaInfo
        title="On-Demand App Development | Custom Software Development | CruxBytes"
        description="Build custom software around your exact requirements. CruxBytes on-demand app development delivers scalable, secure, user-friendly web and mobile applications."
        keywords="on-demand app development, custom software development, web application development, mobile app development, scalable software, CruxBytes"
        url={`https://www.cruxbytes.com${ROUTES.ON_DEMAND_APP_DEVELOPMENT}`}
      /> */}
       <MetaInfo
     title={label} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Software Development -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* On demand app development */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Build scalable software tailored to your unique business needs. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
         {/* Section 1 */}

        <section className="section-py bg-linear-gradient-light text-center"  aria-labelledby="on-demand-intro-heading">
          <div className="container">
            <p data-aos="fade-up">Every business has unique technology requirements. Good application development is not just about making software work. It is about creating software that remains dependable as the business, technology, and user base evolve. We develop custom applications that address specific business needs, streamline processes, improve user experiences, and provide a strong foundation for future growth.</p>
            <p data-aos="fade-up" data-aos-delay={100}>From business applications and customer-facing platforms to workflow solutions and specialized enterprise systems, CruxBytes combines modern development practices with scalable architecture to build reliable software that is ready to evolve with your business. Our motto remains the same over the last 2 decades: “Delivering Technology. Enabling Businesses.”</p>
            <div className="section-header pt-4" data-aos="fade-up" data-aos-delay={200}>
              <span className='text-highlight-light' id="on-demand-intro-heading">We Build What Your Business Actually Needs</span>
              <p >
                Off-the-shelf software may not always fit your processes, users, or growth plans. Our on-demand application development approach enables you to build software around your exact requirements while maintaining the flexibility to adapt as those requirements change over a period of time.
              </p>
            </div>

            <div className="card-grid card-grid--cols-2">
              {ON_DEMAND_FEATURES.map(({ title, desc }, index) => (
                <div
                  key={title}
                  className="card card--row card--start"
                  data-aos="fade-up"
                  data-aos-delay={(index % 2) * 100}
                  style={{gap:'var(--sp-5)'}}
                >
                  <span className="icon-circle me-0" aria-hidden="true">
                    <i className="fa-solid fa-thumbs-up" />
                  </span>
                  <div >
                    <h3 className='wcs-offer-title'>{title}</h3>
                    <p>{desc}</p>
                  </div>
                </div>
              ))}
            </div>
             <div className=" pt-5" data-aos="fade-up">
            
              <p >
                Have a process that needs to be digitized, a business idea that needs a technology platform, or an existing application that needs to evolve?
                Share your requirement with us. We can help shape it into a practical application architecture, development roadmap, and scalable digital solution.
              </p>
               <p className="text-highlight">
                Let's discuss your technology goals and build a roadmap for what's next.
              </p>
              <div className="pt-4">
                <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
                  Get Started
                </Button>
              </div>
            </div>
          </div>
        </section>
         {/* Section 2 */}
        <section className="section-py" aria-labelledby="on-demand-capabilities-heading">
          <div className="container">
            <div className="section-header" data-aos="fade-up">
              <h2 id="on-demand-capabilities-heading">Our On-Demand Application Development Capabilities</h2>
            </div>

            {ON_DEMAND_CAPABILITIES.map(({ title, desc, features, image }, index) => (
              <article
                key={title}
                className={` bgs-row${index % 2 ? ' bgs-row--media-left' : ''}`}
              >
                <div className="bgs-row-content feature-block" data-aos="fade-up">
                  <span className="feature-block-number" aria-hidden="true">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3>{title}</h3>
                  <p>{desc}</p>

                  <div className="feature-block-features">
                    <p className="feature-block-label" id={`capability-${index + 1}-features`}>
                      Key features
                    </p>
                    <ul className="feature-block-list" aria-labelledby={`capability-${index + 1}-features`}>
                      {features.map((feature) => (
                        <li key={feature}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="bgs-row-media bgs-row-media--fade" data-aos="fade-up">
                  <div className="bgs-row-media-inner">
                    <img
                      src={`${ON_DEMAND_IMG_BASE}/${image}`}
                      alt={title}
                      width="1200"
                      height="900"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
  {/* Section 3 */}
  <section className="section-py stack-section" aria-labelledby="on-demand-capabilities-heading">
          <div className="container">
            <h4 className='text-center' data-aos="fade-up">Our engineering approach focuses on:</h4>
          <div className="domain-grid" aria-label="List of industries we serve">
                {domainRows.map((row, rowIdx) => (
                  <div key={rowIdx} className="domain-row">
                    {row.map((domain, chipIdx) => (
                      <span
                        key={domain.name}
                        className="domain-chip"
                        style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                        data-aos="fade-up"
                        data-aos-delay={chipIdx * 30}
                      >
                        {domain.name}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
 
          </div>
        </section>
 {/* Section 4 */}
         <section className="section-py ">
                <div className="container ">
        <div className="on-demand-split">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
        
          <div className="cp-timeline-header">
            <h2 >From Requirement to Production</h2>
            <p >
            Your application may start with a focused requirement and eventually become a critical business platform. We therefore design applications with future expansion in mind.
            </p>
            <p>A scalable architecture makes it easier to introduce new modules, integrate external systems, support increasing users and transactions, and adopt emerging technologies without disrupting the core application.</p>
          </div>     
        </div>
                          {/* ── RIGHT:  ── */}
                  <div   data-aos="fade-left">  
                    <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>
                      <p style={{ paddingBottom: '1.2rem' }}>
                        Our development process covers the complete application lifecycle:
                      </p>
                      <ol className="step-flow" role="list" aria-label="Application development lifecycle">
                        {ON_DEMAND_LIFECYCLE.map((step) => (
                          <li key={step} className="step-flow-item">
                            <span className="step-flow-label">{step}</span>
                          </li>
                        ))}
                      </ol>
                    </div>
                  </div>

                  </div>
                  <div className="media-callout" data-aos="fade-up">
        
          <h3 className="card--rounded-xl media-callout-text">
  <span className="gradient-text">
    Software that is reliable today, adaptable tomorrow, and ready to scale when your business demands it.
  </span>
</h3>
        </div>
        <p data-aos="fade-up" data-aos-delay={100}> We work closely with stakeholders to understand the business requirement, translate it into a practical technology solution, develop the application using modern engineering practices, and continuously improve it based on changing business needs.
</p>
<p data-aos="fade-up" data-aos-delay={200}>Our approach combines modern development practices, thoughtful architecture, reusable components, and scalable technology foundations to create software that can evolve as your business grows.
</p>
       
     
                </div>
                
         </section>
         <TransformBanner />
         </main></>
  )
}